import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-37477330"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maincontainer pt-3 px-5" }
const _hoisted_2 = { class: "headercontainer flex justify-between" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Courses", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { else: "" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" })
], -1))
const _hoisted_7 = { class: "buttonposition" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btnprimary" }, "Add Course", -1))
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-center w-full h-16"
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-wrap gap-2"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "h-1/2" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "bg-primary flex justify-center items-center p-1 rounded-t"
}
const _hoisted_15 = { class: "card-body p-4 h-1/2" }
const _hoisted_16 = { class: "overflow-ellipsis text-justify text-black" }
const _hoisted_17 = {
  key: 2,
  class: "mt-8 text-sm text-center text-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dots_loader = _resolveComponent("dots-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.allCourses.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, { to: { name: 'add-course' } }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.dataLoading == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_dots_loader)
        ]))
      : (_ctx.allCourses.length != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCourses, (course) => {
              return (_openBlock(), _createElementBlock("div", {
                key: course._id,
                class: "mt-2"
              }, [
                _createElementVNode("div", {
                  class: "card cursor-pointer rounded",
                  onClick: ($event: any) => (_ctx.onedit(course))
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("figure", null, [
                      (course.courseImageUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: course.courseImageUrl,
                            class: "flex justify-center items-center rounded-t"
                          }, null, 8, _hoisted_13))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("h1", {
                              class: _normalizeClass(["text-white text-lg", course.courseName.length > 40? 'table-ellipsis':''])
                            }, _toDisplayString(course.courseName), 3)
                          ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h1", {
                      class: _normalizeClass(course.courseName.length > 40? 'table-ellipsis':'')
                    }, _toDisplayString(course.courseName), 3),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(course.courseDescription), 1)
                  ])
                ], 8, _hoisted_11)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, "No courses. Please create one"))
  ]))
}